<script setup>
const { error } = defineProps({ error: Object })

const getTitle = () =>
  error.statusCode == 404 ? '페이지를 찾을 수 없습니다.' : error.name
const getDescription = () =>
  error.statusCode == 404
    ? '페이지가 존재하지 않거나, 사용할 수 없는 페이지입니다. 입력하신 주소가 정확한지 다시 한번 확인해 주세요.'
    : error.message

console.error(`🚀 ~ file: error.vue:10 ~ error`, error.name, error.message)

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <NuxtLayout name="full-screen">
    <LayoutXl
      class="flex flex-col items-center justify-center text-center h-screen"
    >
      <h1 class="font-bold text-verdigris-500 text-[5rem]">
        {{ error.statusCode }}
      </h1>
      <p class="mt-5 | text-46 text-verdigris-500">
        {{ getTitle() }}
      </p>
      <p class="mt-4 | text-18">{{ getDescription() }}</p>
      <Button
        class="mt-12 | w-[312px]"
        size="large"
        rounded
        label="돌아가기"
        @click="handleError"
      />
    </LayoutXl>
  </NuxtLayout>
</template>
